import React from 'react'
import styles from './Species.module.css'
import moment from 'moment'


const Species = ({ response }) => {

    return (
        <div className={styles.species}>
            <div>
                <img src={response.imageUrl} alt={response.commonName} className={styles.image}/>
            </div>
            <div className={styles.name}>
                <p>{response.user} identified <span style={{fontWeight: "bold"}}>{response.commonName} </span> in {response.location} <span className={styles.sciName}>{moment(response.createdAt).fromNow()} </span></p>
            </div>
            <div className={styles.buttons}>
                {/* <button onClick={() => dispatch(deleteSpecies(response._id))}><i className="far fa-trash-alt"></i></button> */}
            </div>
        </div>
    )
}

export default Species
